module.exports = __webpack_public_path__ + "img/codelogo-en.9a2dc754.png";